import _ from 'lodash'


export default {
  tips: (state) => _.orderBy(state.tips, 'sentAt', 'desc'),
  unreadTipsCount: (state) => _.size(_.filter(state.tips, (tip) => tip.unread)),
}
